import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { store } from 'react-notifications-component';

import GenericUpper from '../../components/generic-upper';
import ModalGeneric from '../../components/modal/modalGeneric';
import CardRadio from '../../components/cardRadio';
import Button from '../../components/button/button_v2';
import Input from '../../components/input/input_v2';
import CircularGauge from '../../components/circularGauge';
import TextOrStatus from '../../components/textOrStatus';
import { Loading } from '../../components/loading';
import TableWithLabelBlackV2 from '../../components/TableWithLabelBlack/indexV2';

import * as S from './styles'

import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import maintainUtm from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from '../../services/maintainUtm/idPages';
import { theme } from '../../styles/theme';
import { H4, BodyM, BodyP, BodyPSpan, Auxiliar, TaglineMSpan } from '../../styles/stylesTypography';

import {
    Container, Secao, SecaoHead, PlanoAtualHead, PlanoAtualDescricao, Card, GridDuas, PlanoMeta, PlanoMetaLinha,
    AcoesPlano, GaugeCard, Badge, PlanoNomeTitulo, Cartao, BandeiraCartao, CobrancaInfo, CobrancaLinha,
    TabelaWrap, ZonaCancel, ModalTexto, CamposCartaoGrid, ModalFootRow,
    FormaPagamentoOpcoes, FormaPagamentoLabel,
    Skeleton, SkeletonLinha, LinkAcao, FaturaLinks, FaturaDot
} from './styles';

const URL_CANCELAMENTO = 'https://agroreceita.com.br/cancelamento/';

const IconPessoa = ({ color }) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="5" r="2.5" stroke={color} strokeWidth="1.5" />
        <path d="M3 13.5c.7-2.3 2.7-3.5 5-3.5s4.3 1.2 5 3.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const CARTAO_INICIAL = {
    numero_cartao: '', nome_cartao: '', validade: '', ccv: '',
};

const parseValorBR = (valor) => {
    if (valor === null || valor === undefined || valor === '') return 0;
    if (typeof valor === 'number') return valor;
    let texto = String(valor).trim();
    if (texto.includes(',')) {
        texto = texto.replace(/\./g, '').replace(',', '.');
    }
    const numero = Number(texto);
    return Number.isNaN(numero) ? 0 : numero;
};

const formatMoney = (valor) => parseValorBR(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
});

const BANDEIRAS_ABREVIADAS = {
    mastercard: 'Master',
    visa: 'Visa',
    amex: 'Amex',
    'american express': 'Amex',
    elo: 'Elo',
    hipercard: 'Hiper',
    diners: 'Diners',
    'diners club': 'Diners',
    discover: 'Discover',
    jcb: 'JCB',
    aura: 'Aura',
};

const abreviarBandeira = (bandeira) => {
    if (!bandeira) return 'Cartão';
    return BANDEIRAS_ABREVIADAS[bandeira.trim().toLowerCase()] || bandeira.slice(0, 8);
};

const formatDate = (data) => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};

const MESES_ABREVIADOS = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

const formatDateAbreviada = (data) => {
    if (!data) return '';
    const d = new Date(data);
    const dia = String(d.getUTCDate()).padStart(2, '0');
    const mes = MESES_ABREVIADOS[d.getUTCMonth()];
    return `${dia} ${mes} ${d.getUTCFullYear()}`;
};

// Mesmas regras de validação já usadas na tela de compra (pages/compra/index.js)
const validarNumeroCartao = (numero) => {
    const cleaned = (numero || '').replace(/\D/g, '');
    if (cleaned.length < 13 || cleaned.length > 19) return false;

    let sum = 0;
    let shouldDouble = false;
    for (let i = cleaned.length - 1; i >= 0; i--) {
        let digit = parseInt(cleaned.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};

const validarValidadeCartao = (validade) => {
    const [mes, ano] = (validade || '').split('/');
    if (!mes || !ano || mes.length !== 2 || ano.length !== 2) return false;

    const numericMonth = parseInt(mes, 10);
    const numericYear = parseInt(`20${ano}`, 10);
    if (numericMonth < 1 || numericMonth > 12) return false;

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    if (numericYear < currentYear || (numericYear === currentYear && numericMonth < currentMonth)) return false;

    return true;
};

const validarCvvCartao = (cvv) => /^[0-9]{3,4}$/.test(cvv || '');

const notificar = (title, message, type) => {
    store.addNotification({
        title,
        message,
        type,
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: { duration: 5000, onScreen: true }
    });
};

const GerenciarPlano = ({ ...props }) => {
    const [carregando, setCarregando] = useState(true);
    const [contrato, setContrato] = useState(null);
    const [plano, setPlano] = useState(null);
    const [uso, setUso] = useState(null);
    const [contaInfo, setContaInfo] = useState(null);
    const [loadingContaInfo, setLoadingContaInfo] = useState(true);
    const [faturas, setFaturas] = useState([]);
    const [loadingFaturas, setLoadingFaturas] = useState(true);

    const [showCartaoModal, setShowCartaoModal] = useState(false);
    const [metodoPagamento, setMetodoPagamento] = useState(null);
    const [cartaoForm, setCartaoForm] = useState(CARTAO_INICIAL);
    const [loadingCartao, setLoadingCartao] = useState(false);
    const [errosCartao, setErrosCartao] = useState({});

    const [showLicencasModal, setShowLicencasModal] = useState(false);
    const [usuariosLicencas, setUsuariosLicencas] = useState([]);
    const [totalLicencas, setTotalLicencas] = useState(0);
    const [licencasUsadas, setLicencasUsadas] = useState(0);
    const [loadingLicencas, setLoadingLicencas] = useState(false);

    const getPlano = async () => {
        try {
            const response = await api.get('/planos');
            setContrato(response.data.data?.contrato);
            setPlano(response.data.data?.plano);
        } catch (error) {
            notificar('Erro!', identifyErrorMenssage(error), 'danger');
        }
    };

    const getUso = async () => {
        try {
            const response = await api.get('/planos/qtd-receitas');
            setUso(response.data.data);
        } catch (error) { }
    };

    const getContaInfo = async () => {
        setLoadingContaInfo(true);
        try {
            const response = await api.get('/planos/conta/info');
            setContaInfo(response.data.data);
        } catch (error) { }
        setLoadingContaInfo(false);
    };

    const getFaturas = async () => {
        setLoadingFaturas(true);
        try {
            const response = await api.get('/planos/faturas');
            setFaturas(response.data.data || []);
        } catch (error) {
            setFaturas([]);
        }
        setLoadingFaturas(false);
    };

    const carregarTudo = async () => {
        setCarregando(true);
        await Promise.all([getPlano(), getUso(), getContaInfo(), getFaturas()]);
        setCarregando(false);
    };

    useEffect(() => {
        carregarTudo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const statusInfo = (() => {
        if (!contrato) return { status: 2, texto: 'Ativo' };
        if (contrato.status === 'CA') {
            const aindaTemAcesso = contrato.agro_plans_config?.date_next_renewal
                ? new Date(contrato.agro_plans_config.date_next_renewal) >= new Date()
                : false;
            return aindaTemAcesso
                ? { status: 5, texto: `Cancela em ${formatDate(contrato.agro_plans_config?.date_next_renewal)}` }
                : { status: 1, texto: 'Cancelado' };
        }
        return { status: 2, texto: 'Ativo' };
    })();

    // Créditos disponíveis só fazem sentido em planos por consumo (pré-pago/basic) - nos demais o
    // ciclo de receitas não é limitado por saldo, então o bloco fica escondido.
    const nomePlanoAtual = plano?.plans?.plan_name || contrato?.nome_plano || '';
    const exibirCreditos = nomePlanoAtual === 'PLANO BASIC' || nomePlanoAtual === 'PLANO PRÉ-PAGO';

    const abrirModalCartao = () => {
        setCartaoForm(CARTAO_INICIAL);
        setErrosCartao({});
        setMetodoPagamento(null);
        setShowCartaoModal(true);
    };

    const selecionarMetodoPagamento = (metodo) => {
        setMetodoPagamento(metodo);
        setErrosCartao({});
    };

    const getUsuariosLicencas = async () => {
        setLoadingLicencas(true);
        try {
            const response = await api.get('/users/licencas');
            setUsuariosLicencas(Array.isArray(response.data?.usuarios) ? response.data.usuarios : []);
            setTotalLicencas(response.data?.total || 0);
            setLicencasUsadas(response.data?.usadas || 0);
        } catch (error) {
            setUsuariosLicencas([]);
            setTotalLicencas(0);
            setLicencasUsadas(0);
        }
        setLoadingLicencas(false);
    };

    const abrirLicencas = () => {
        setShowLicencasModal(true);
        getUsuariosLicencas();
    };

    const irParaComprarLicenca = () => {
        setShowLicencasModal(false);
        props.history.push('/plano/edit');
    };

    const alterarCampoCartao = (campo, valor) => {
        setCartaoForm(prev => ({ ...prev, [campo]: valor }));
        setErrosCartao(prev => ({ ...prev, [campo]: false }));
    };

    const salvarCartao = async () => {
        const erros = {
            nome_cartao: !cartaoForm.nome_cartao?.trim(),
            numero_cartao: !validarNumeroCartao(cartaoForm.numero_cartao),
            validade: !validarValidadeCartao(cartaoForm.validade),
            ccv: !validarCvvCartao(cartaoForm.ccv),
        };
        setErrosCartao(erros);
        if (Object.values(erros).some(Boolean)) return;

        if (!contaInfo?.contact_id_cartao) {
            notificar('Erro!', 'Não encontramos o contato de cobrança desta empresa - Entre em contato com o suporte.', 'danger');
            return;
        }

        setLoadingCartao(true);
        try {
            const [expiracao_mes, expiracao_ano] = cartaoForm.validade.split('/');
            await api.put('/planos/atualizar_cartao', {
                contact_id: contaInfo.contact_id_cartao,
                nome_cartao: cartaoForm.nome_cartao,
                numero_cartao: cartaoForm.numero_cartao,
                expiracao_mes,
                expiracao_ano,
                ccv: cartaoForm.ccv,
            });
            notificar('Sucesso!', 'Cartão atualizado com sucesso!', 'success');
            setShowCartaoModal(false);
            getContaInfo();
        } catch (error) {
            notificar('Erro!', identifyErrorMenssage(error), 'danger');
        }
        setLoadingCartao(false);
    };

    const salvarFormaPagamentoSemCartao = async (billingType) => {
        setLoadingCartao(true);
        try {
            await api.put('/planos/forma_pagamento', { billingType });
            notificar('Sucesso!', 'Forma de pagamento atualizada com sucesso!', 'success');
            setShowCartaoModal(false);
            getContaInfo();
        } catch (error) {
            notificar('Erro!', identifyErrorMenssage(error), 'danger');
        }
        setLoadingCartao(false);
    };

    const confirmarFormaPagamento = () => {
        if (metodoPagamento === 'cartao_credito') {
            salvarCartao();
        } else if (metodoPagamento === 'pix') {
            salvarFormaPagamentoSemCartao('PIX');
        } else if (metodoPagamento === 'boleto') {
            salvarFormaPagamentoSemCartao('BOLETO');
        }
    };

    const statusFaturaCode = (status) => {
        if (status === 'Paga') return 2;
        if (status === 'Reembolsada') return 5;
        if (status === 'Cancelada' || status === 'Vencida') return 3;
        return 1;
    };

    const exportarFaturas = () => {
        const linhas = [
            ['Data', 'Descrição', 'Valor', 'Status', 'Nota fiscal', 'Recibo'],
            ...faturas.map((fatura) => [
                formatDate(fatura.data),
                fatura.descricao || '',
                formatMoney(fatura.valor),
                fatura.status,
                fatura.nota_fiscal_url || '',
                fatura.boleto_url || '',
            ]),
        ];

        const csv = linhas
            .map((linha) => linha.map((campo) => `"${String(campo).replace(/"/g, '""')}"`).join(';'))
            .join('\r\n');

        const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'historico-faturas-agroreceita.csv';
        link.click();
        URL.revokeObjectURL(url);
    };

    return (
        <>
            <GenericUpper
                title="Gerenciar plano"
                subtitle="Acompanhe e gerencie sua assinatura"
            />

            <Container>
                <Secao>
                    <PlanoAtualHead>
                        <H4>Plano atual</H4>
                        <TextOrStatus
                            type="status"
                            status={statusInfo.status}
                            textDefault={statusInfo.texto}
                            textSuccess={statusInfo.texto}
                            textWaiting={statusInfo.texto}
                            maxWidth="auto"
                        />
                        <PlanoAtualDescricao>
                            <BodyP color={theme.colors.gray.Cinza_7}>Detalhes da sua assinatura e uso no ciclo vigente</BodyP>
                        </PlanoAtualDescricao>
                    </PlanoAtualHead>

                    <GridDuas single={!carregando && !exibirCreditos}>
                        {carregando ? (
                            <Card>
                                <Skeleton width="60%" height="28px" />
                                <div style={{ marginTop: 12 }}>
                                    <Skeleton width="40%" height="14px" />
                                </div>
                                <PlanoMeta>
                                    <SkeletonLinha><Skeleton width="30%" /><Skeleton width="25%" /></SkeletonLinha>
                                    <SkeletonLinha><Skeleton width="30%" /><Skeleton width="25%" /></SkeletonLinha>
                                    <SkeletonLinha><Skeleton width="30%" /><Skeleton width="25%" /></SkeletonLinha>
                                </PlanoMeta>
                                <AcoesPlano>
                                    <Skeleton width="180px" height="42px" radius="500px" />
                                </AcoesPlano>
                            </Card>
                        ) : (
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                    <PlanoNomeTitulo>{plano?.plans?.plan_name || contrato?.nome_plano || '-'}</PlanoNomeTitulo>
                                    {/* recorrencia vem calculada do ciclo de cobranca pela API.
                                        agro_plans_renew_types.descricao nao serve aqui: ha contratos
                                        com ciclo anual gravados como MENSAL. */}
                                    {plano?.recorrencia && (
                                        <Badge background={theme.colors.gray.Cinza_1} color={theme.colors.white.Branco}>
                                            {plano.recorrencia}
                                        </Badge>
                                    )}
                                </div>

                                <BodyP color={theme.colors.gray.Cinza_6}>
                                    <BodyPSpan>{formatMoney(Number(contrato?.qtd_adquirida) > 0 ? parseValorBR(plano?.plan_value) / Number(contrato.qtd_adquirida) : plano?.plan_value)}</BodyPSpan> por licença · {contrato?.qtd_adquirida || 0} licenças
                                </BodyP>

                                <PlanoMeta>
                                    <PlanoMetaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>Assinante desde</BodyP>
                                        <BodyP fontWeight={700}>{formatDate(plano?.date_purchase)}</BodyP>
                                    </PlanoMetaLinha>
                                    <PlanoMetaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>Próxima cobrança</BodyP>
                                        <BodyP fontWeight={700}>{formatDate(plano?.date_next_renewal)}</BodyP>
                                    </PlanoMetaLinha>
                                    <PlanoMetaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>Ciclo atual</BodyP>
                                        <BodyP fontWeight={700}>{formatDate(plano?.date_last_renewal)} – {formatDate(plano?.date_next_renewal)}</BodyP>
                                    </PlanoMetaLinha>
                                </PlanoMeta>

                                <AcoesPlano>
                                    <Button
                                        value="GERENCIAR LICENÇAS"
                                        outline
                                        color={theme.colors.gray.Cinza_2}
                                        width="auto"
                                        height="42px"
                                        iconNode={<IconPessoa color={theme.colors.gray.Cinza_2} />}
                                        onClick={() => abrirLicencas()}
                                    />
                                    <Button
                                        value="VER PLANOS"
                                        width="auto"
                                        height="42px"
                                        onClick={() => props.history.push(`/planos${maintainUtm(`${getCurrentPageIdWithDevice()}-gerenciarplanoverplanos`)}`)}
                                    />
                                </AcoesPlano>
                            </Card>
                        )}

                        {(carregando || exibirCreditos) && (
                            <GaugeCard>
                                {carregando ? (
                                    <>
                                        <Skeleton width="140px" height="140px" radius="50%" />
                                        <div style={{ width: '100%' }}>
                                            <Skeleton width="60%" height="12px" />
                                            <div style={{ marginTop: 8 }}>
                                                <Skeleton width="80%" height="12px" />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <CircularGauge
                                            total={uso?.limite_receitas || 0}
                                            restante={uso?.saldo_receitas || 0}
                                            ilimitado={!!uso && (uso.limite_receitas === null || uso.limite_receitas === undefined)}
                                        />
                                        <div>
                                            <Auxiliar fontWeight={800}>Créditos disponíveis</Auxiliar>
                                            <BodyP color={theme.colors.gray.Cinza_7}>Renova em {formatDate(plano?.date_next_renewal)}</BodyP>
                                        </div>
                                    </>
                                )}
                            </GaugeCard>
                        )}
                    </GridDuas>
                </Secao>

                <Secao>
                    <SecaoHead>
                        <div>
                            <H4>Forma de pagamento</H4>
                            <BodyP color={theme.colors.gray.Cinza_7}>Dados usados na sua cobrança recorrente</BodyP>
                        </div>
                    </SecaoHead>

                    <GridDuas>
                        {loadingContaInfo ? (
                            <Cartao>
                                <Skeleton width="52px" height="34px" radius="6px" />
                                <div style={{ flex: 1 }}>
                                    <Skeleton width="70%" height="14px" />
                                    <div style={{ marginTop: 8 }}>
                                        <Skeleton width="40%" height="12px" />
                                    </div>
                                </div>
                                <Skeleton width="90px" height="38px" radius="500px" />
                            </Cartao>
                        ) : (
                            <Cartao>
                                <BandeiraCartao>
                                    <Auxiliar color={theme.colors.white.Branco} fontWeight={800}>
                                        {contaInfo?.forma_pagamento === 'PIX' ? 'Pix' : contaInfo?.forma_pagamento === 'BOLETO' ? 'Boleto' : abreviarBandeira(contaInfo?.pagamento?.bandeira)}
                                    </Auxiliar>
                                </BandeiraCartao>
                                <div style={{ flex: 1 }}>
                                    {contaInfo?.forma_pagamento === 'PIX' ? (
                                        <>
                                            <BodyM fontWeight={700}>Pagamento via Pix</BodyM>
                                            <BodyP color={theme.colors.gray.Cinza_7}>Cobrança gerada a cada ciclo</BodyP>
                                        </>
                                    ) : contaInfo?.forma_pagamento === 'BOLETO' ? (
                                        <>
                                            <BodyM fontWeight={700}>Pagamento via Boleto</BodyM>
                                            <BodyP color={theme.colors.gray.Cinza_7}>Cobrança gerada a cada ciclo</BodyP>
                                        </>
                                    ) : contaInfo?.pagamento ? (
                                        <>
                                            <BodyM fontWeight={700}>{contaInfo.pagamento.bandeira} terminando em {contaInfo.pagamento.final}</BodyM>
                                            {contaInfo.pagamento.validade && (
                                                <BodyP color={theme.colors.gray.Cinza_7}>Expira em {contaInfo.pagamento.validade}</BodyP>
                                            )}
                                        </>
                                    ) : (
                                        <BodyM color={theme.colors.gray.Cinza_7}>Nenhuma forma de pagamento cadastrada</BodyM>
                                    )}
                                </div>
                                <Button value="ALTERAR" outline color={theme.colors.gray.Cinza_2} width="auto" height="38px" onClick={() => abrirModalCartao()} />
                            </Cartao>
                        )}

                        {carregando ? (
                            <Card>
                                <SkeletonLinha><Skeleton width="30%" /><Skeleton width="30%" /></SkeletonLinha>
                                <SkeletonLinha><Skeleton width="20%" /><Skeleton width="30%" /></SkeletonLinha>
                                <SkeletonLinha><Skeleton width="35%" /><Skeleton width="35%" /></SkeletonLinha>
                            </Card>
                        ) : (
                            <Card>
                                <CobrancaInfo>
                                    <CobrancaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>Razão social</BodyP>
                                        <BodyP fontWeight={700}>{contaInfo?.company?.razao_social || '-'}</BodyP>
                                    </CobrancaLinha>
                                    <CobrancaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>CNPJ</BodyP>
                                        <BodyP fontWeight={700}>{contaInfo?.company?.cnpj || contaInfo?.company?.cpf || '-'}</BodyP>
                                    </CobrancaLinha>
                                    <CobrancaLinha>
                                        <BodyP color={theme.colors.gray.Cinza_6}>E-mail de cobrança</BodyP>
                                        <BodyP fontWeight={700}>{contaInfo?.faturamento?.email || '-'}</BodyP>
                                    </CobrancaLinha>
                                    <CobrancaLinha>
                                        <span />
                                        <a href="/faturamento">
                                            <TaglineMSpan fontWeight={800} color="#589BFF">Editar dados de cobrança</TaglineMSpan>
                                        </a>
                                    </CobrancaLinha>
                                </CobrancaInfo>
                            </Card>
                        )}
                    </GridDuas>
                </Secao>

                {false && (
                <Secao>
                    <SecaoHead>
                        <div>
                            <H4>Histórico de faturas</H4>
                            <BodyP color={theme.colors.gray.Cinza_7}>Cobranças da sua assinatura</BodyP>
                        </div>
                        <LinkAcao disabled={faturas.length === 0} onClick={() => exportarFaturas()} style={{ color: theme.colors.blue.Azul_link }}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7 2v7M4 6.5L7 9.5l3-3M2.5 11.5h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <TaglineMSpan color={theme.colors.blue.Azul_link}>Exportar tudo</TaglineMSpan>
                        </LinkAcao>
                    </SecaoHead>

                    <TabelaWrap>
                        <TableWithLabelBlackV2
                            columns={[
                                {
                                    key: 'data',
                                    label: 'Data',
                                    minWidth: '110px',
                                    width: '110px',
                                    render: (fatura) => <BodyP fontWeight={700}>{formatDate(fatura.data)}</BodyP>
                                },
                                {
                                    key: 'descricao',
                                    label: 'Descrição',
                                    width: '100%',
                                    minWidth: '300px',
                                    maxWidth: '300px',
                                    maxWidthContent: '300px',
                                    enableHorizontalScroll: true,
                                    render: (fatura) => <BodyP>{fatura.descricao}</BodyP>
                                },
                                {
                                    key: 'valor',
                                    label: 'Valor',
                                    minWidth: '110px',
                                    width: '110px',
                                    render: (fatura) => <BodyP fontWeight={800}>{formatMoney(fatura.valor)}</BodyP>
                                },
                                {
                                    key: 'status',
                                    label: 'Status',
                                    minWidth: '110px',
                                    width: '110px',
                                    render: (fatura) => (
                                        <TextOrStatus
                                            type="status"
                                            status={statusFaturaCode(fatura.status)}
                                            textDefault={fatura.status}
                                            textSuccess="Paga"
                                            textError="Cancelada"
                                            textWaiting="Reembolsada"
                                            maxWidth="auto"
                                        />
                                    )
                                },
                                {
                                    key: 'documentos',
                                    label: 'Documentos',
                                    minWidth: '160px',
                                    width: '100%',
                                    render: (fatura) => (
                                        <FaturaLinks>
                                            {fatura.nota_fiscal_url && (
                                                <a href={fatura.nota_fiscal_url} target="_blank" rel="noreferrer">
                                                    <TaglineMSpan fontWeight={800} color="#589BFF">Nota fiscal</TaglineMSpan>
                                                </a>
                                            )}
                                            {fatura.nota_fiscal_url && fatura.boleto_url && <FaturaDot>•</FaturaDot>}
                                            {fatura.boleto_url && (
                                                <a href={fatura.boleto_url} target="_blank" rel="noreferrer">
                                                    <TaglineMSpan fontWeight={800} color="#589BFF">Recibo</TaglineMSpan>
                                                </a>
                                            )}
                                            {!fatura.nota_fiscal_url && !fatura.boleto_url && '-'}
                                        </FaturaLinks>
                                    )
                                }
                            ]}
                            data={faturas}
                            getRowId={(fatura) => fatura.id}
                            showAll={true}
                            serverSide={true}
                            itemsPerPage={faturas.length || 8}
                            enableDefaultRowNavigation={false}
                            isLoading={loadingFaturas}
                            emptyMessage="Nenhuma fatura encontrada para esta assinatura."
                        />
                    </TabelaWrap>
                </Secao>
                )}

                <Secao>
                    <ZonaCancel>
                        <div>
                            <BodyM fontWeight={800}>Cancelar assinatura</BodyM>
                            <BodyP color={theme.colors.gray.Cinza_6}>
                                Seu acesso continua até o fim do ciclo pago{plano?.date_next_renewal ? ` (${formatDate(plano.date_next_renewal)})` : ''}. Nenhuma cobrança futura será feita.
                            </BodyP>
                        </div>
                        <Button
                            value="CANCELAR ASSINATURA"
                            outline
                            red
                            width="auto"
                            height="42px"
                            disabled={carregando || contrato?.status === 'CA'}
                            onClick={() => { window.open(URL_CANCELAMENTO, '_blank', 'noopener,noreferrer'); }}
                        />
                    </ZonaCancel>
                </Secao>
            </Container>

            {/* Modal alterar cartão */}
            <ModalGeneric show={showCartaoModal} onHide={() => setShowCartaoModal(false)} width="570px" marginBottom="0px">
                <S.ContainerModalGerenciar>
                    <H4>Alterar forma de pagamento</H4>

                    <ModalTexto>
                        A nova forma de pagamento será usada a partir da próxima cobrança{plano?.date_next_renewal ? `, em ${formatDateAbreviada(plano.date_next_renewal)}.` : '.'}
                    </ModalTexto>

                    <FormaPagamentoOpcoes>
                        <CardRadio
                            id="pix"
                            selected={metodoPagamento === 'pix'}
                            checked={metodoPagamento === 'pix'}
                            onClick={() => selecionarMetodoPagamento('pix')}
                            onChange={() => selecionarMetodoPagamento('pix')}
                        >
                            <FormaPagamentoLabel>
                                <BodyM fontWeight={700}>Pix</BodyM>
                                <BodyP color={theme.colors.gray.Cinza_6}>Liberação imediata</BodyP>
                            </FormaPagamentoLabel>
                        </CardRadio>

                        <CardRadio
                            id="boleto"
                            selected={metodoPagamento === 'boleto'}
                            checked={metodoPagamento === 'boleto'}
                            onClick={() => selecionarMetodoPagamento('boleto')}
                            onChange={() => selecionarMetodoPagamento('boleto')}
                        >
                            <FormaPagamentoLabel>
                                <BodyM fontWeight={700}>Boleto</BodyM>
                                <BodyP color={theme.colors.gray.Cinza_6}>Até 3 dias</BodyP>
                            </FormaPagamentoLabel>
                        </CardRadio>

                        <CardRadio
                            id="cartao_credito"
                            selected={metodoPagamento === 'cartao_credito'}
                            checked={metodoPagamento === 'cartao_credito'}
                            onClick={() => selecionarMetodoPagamento('cartao_credito')}
                            onChange={() => selecionarMetodoPagamento('cartao_credito')}
                        >
                            <FormaPagamentoLabel>
                                <BodyM fontWeight={700}>Cartão</BodyM>
                                <BodyP color={theme.colors.gray.Cinza_6}>Liberação imediata</BodyP>
                            </FormaPagamentoLabel>
                        </CardRadio>
                    </FormaPagamentoOpcoes>

                    {metodoPagamento === 'cartao_credito' && (
                    <>
                    <Input
                        id="nome_cartao"
                        label="Nome no cartão" 
                        labelWithAsterisk 
                        value={cartaoForm.nome_cartao} 
                        onChange={(e) => alterarCampoCartao('nome_cartao', e)} 
                        updateValue={(e) => alterarCampoCartao('nome_cartao', `${e}`)} 
                        marginBottom="0px" 
                        height="auto" 
                        minHeight="auto" 
                        erro={errosCartao.nome_cartao} 
                        messageErro="Campo obrigatório" 
                        />

                    <Input 
                        id="numero_cartao" 
                        name="credit-card" 
                        label="Número do cartão" 
                        labelWithAsterisk 
                        value={cartaoForm.numero_cartao} 
                        onChange={(e) => alterarCampoCartao('numero_cartao', e)} 
                        updateValue={(e) => alterarCampoCartao('numero_cartao', `${e}`)} 
                        marginBottom="0px" 
                        height="auto" 
                        minHeight="auto" 
                        erro={errosCartao.numero_cartao} 
                        messageErro="Número de cartão inválido" 
                        />

                    <CamposCartaoGrid duasColunas>
                        <Input 
                            id="validade" 
                            name="validade-cartao" 
                            label="Validade (MM/AA)" 
                            labelWithAsterisk 
                            value={cartaoForm.validade} 
                            onChange={(e) => alterarCampoCartao('validade', e)} 
                            updateValue={(e) => alterarCampoCartao('validade', `${e}`)} 
                            marginBottom="0px" 
                            height="auto" 
                            minHeight="auto" 
                            erro={errosCartao.validade} 
                            messageErro="Validade inválida ou expirada" 
                            />

                        <Input 
                            id="ccv" 
                            name="cvv" 
                            label="CVV" 
                            labelWithAsterisk 
                            value={cartaoForm.ccv} 
                            onChange={(e) => alterarCampoCartao('ccv', e)} 
                            updateValue={(e) => alterarCampoCartao('ccv', `${e}`)} 
                            marginBottom="0px" 
                            height="auto" 
                            minHeight="auto" 
                            erro={errosCartao.ccv} 
                            messageErro="CVV inválido" 
                            />
                    </CamposCartaoGrid>
                    </>
                    )}

                    <ModalFootRow spaced>
                        <Button value="CANCELAR" outline color={theme.colors.gray.Cinza_2} width="auto" height="44px" onClick={() => setShowCartaoModal(false)} />
                        <Button value="SALVAR" width="auto" height="44px" loading={loadingCartao} disabled={!metodoPagamento} onClick={() => confirmarFormaPagamento()} />
                    </ModalFootRow>
                </S.ContainerModalGerenciar>
            </ModalGeneric>

            {/* Modal gerenciar licenças */}
            <ModalGeneric show={showLicencasModal} onHide={() => setShowLicencasModal(false)} width="500px" marginBottom="0px">
                <S.ContainerModalGerenciar>
                    <H4>Gerenciar licenças</H4>
                    <ModalTexto>
                        Seu plano <BodyPSpan>{plano?.plans?.plan_name || contrato?.nome_plano || '-'}</BodyPSpan> tem <BodyPSpan>{totalLicencas} licença{totalLicencas === 1 ? '' : 's'}</BodyPSpan>, {(() => {
                            const livres = Math.max(totalLicencas - licencasUsadas, 0);
                            return livres === 0 ? 'todas em uso' : `${licencasUsadas} em uso e ${livres} livre${livres === 1 ? '' : 's'}`;
                        })()}. Adicione licenças a <BodyPSpan>{(() => {
                            const valorTotal = parseValorBR(plano?.plan_value);
                            const valorPorLicenca = totalLicencas > 0 ? valorTotal / totalLicencas : valorTotal;
                            const descricaoCiclo = (plano?.agro_plans_renew_types?.descricao || '').toLowerCase();
                            const ciclo = descricaoCiclo.includes('anual') ? 'ano' : 'mês';
                            return `${formatMoney(valorPorLicenca)}/${ciclo}`;
                        })()}</BodyPSpan> cada.
                    </ModalTexto>

                    {loadingLicencas ? (
                        <Loading />
                    ) : (
                        <PlanoMeta>
                            {usuariosLicencas.map((u) => (
                                <PlanoMetaLinha key={u.id}>
                                    <BodyP color={theme.colors.gray.Cinza_6}>{u.nome || '-'}</BodyP>
                                    <BodyP fontWeight={700} color={theme.colors.gray.Cinza_2}>{u.permissao || '-'}</BodyP>
                                </PlanoMetaLinha>
                            ))}
                        </PlanoMeta>
                    )}

                    <ModalFootRow spaced>
                        <Button value="FECHAR" outline color={theme.colors.gray.Cinza_2} width="auto" height="44px" onClick={() => setShowLicencasModal(false)} />
                        <Button value="ADICIONAR LICENÇA" width="auto" height="44px" onClick={() => irParaComprarLicenca()} />
                    </ModalFootRow>
                </S.ContainerModalGerenciar>
            </ModalGeneric>
        </>
    );
};

export default withRouter(GerenciarPlano);
